import gql from 'graphql-tag'
import cl from './client'

var client = cl.get()

function get_image_data (id) {
  return client
    .query({
      //prettier-ignore
      query: gql`query($id: ID!){ imageData(id: $id) }`,
      variables: { id: id }
    })
    .then(res => res.data.imageData)
}

export default {
  add_images_to_question: async q => {
    var r = []
    if (q.contentImage) {
      r.push(get_image_data(q.contentImage))
    }
    if (q.answerImages) {
      for (var j = 0; j < q.answerImages.length; ++j) {
        r.push(get_image_data(q.answerImages[j]))
      }
    }
    if (r.length == 0) {
      return q
    }
    r = await Promise.all(r)
    var k = 0
    if (q.contentImage) {
      q.contentImageData = r[k]
      k++
    }
    if (q.answerImages) {
      q.answerImagesData = []
      for (var j = 0; j < q.answerImages.length; ++j) {
        q.answerImagesData.push(r[k])
        k++
      }
    }
    return q
  },
  save_report: (tsid, type, message) =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`
          mutation($tsid: ID!, $type: ReportType!, $message: String){
            saveReport(tsid: $tsid, type: $type, message: $message){
              success
            }
          }`,
        variables: { tsid: tsid, type: type, message: message }
      })
      .then(res => (res.data ? res.data.saveReport : null)),
  save_answer: (tsid, answer) =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`
          mutation($tsid: ID!, $answer: Int!){
            saveAnswer(tsid: $tsid, answer: $answer){
              success
              solution{data, type}
              refSolution{data, type}
            }
          }`,
        variables: { tsid: tsid, answer: answer }
      })
      .then(res => (res.data ? res.data.saveAnswer : null)),
  submit_ts: tsid =>
    client
      .mutate({
        // prettier-ignore
        mutation: gql`
          mutation($tsid: ID!){
            submitTestSeq(tsid: $tsid){
              success
            }
          }`,
        variables: { tsid: tsid }
      })
      .then(res => (res.data ? res.data.submitTestSeq : null)),
  get_test: id =>
    client
      .query({
        // prettier-ignore
        query: gql`query($id: ID!){
          test(id: $id){
            id
            sequences{
              id, type, answer, submitted
              question{
                key, type, layoutType, content, contentImage, answers, answerImages,
                solution{ data, type }
              }
              refQuestion{
                key, type, layoutType, content, answers,
                solution{ data, type }
              }
            }
          }
        }`,
        variables: { id: id }
      })
      .then(res => (res.data ? res.data.test : null)),
  get_tests: _ =>
    client
      .query({
        // prettier-ignore
        query: gql`query{
          tests{
            id, numSequence, numSubmittedSequence
          }
        }`
      })
      .then(res => (res.data ? res.data.tests : null))
}
